import React, { memo } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Icon, Checkbox } from '@shared/ui';
import { UiButton } from '@shared/ui/UiButton';
import { TaskFilters as Filters, ChangeTaskFilter } from 'entities/task';

import { SelectedFilter } from '../../TasksExtraFilters/lib/hooks/useTaskExtraFilters';
import { useTaskObserversFilter } from '../lib/hooks/useTaskObserversFilter';
import cls from '../TaskObserversFilter.module.css';

interface TaskObserversFilterProps {
    classes?: string;
    isShow: boolean;
    onSelectedFilter: (value: SelectedFilter) => void;
    onFilteredData: ChangeTaskFilter;
    filteredData: Filters;
}

// ? Observers это же наблюдатели

export const TaskObserversFilter = memo(
    ({
        classes,
        onSelectedFilter,
        onFilteredData,
        filteredData,
        isShow,
    }: TaskObserversFilterProps) => {
        const {
            onChangeCheckbox,
            isActiveTypesFilter,
            resetFilterTypes,
            executorsForFilter,
            selectedItemText,
        } = useTaskObserversFilter(onFilteredData, filteredData);
        const { t } = useTranslation();

        return (
            <div className={classNames(cls.TaskObserversFilter, [classes], { [cls.open]: isShow })}>
                <div
                    className={classNames(cls.header)}
                    onClick={() => onSelectedFilter(isShow ? null : 'executors')}
                >
                    <div className={cls.iconWrapper}>
                        <Icon iconName="taskObservers" />
                    </div>
                    {isActiveTypesFilter ? (
                        <div className={cls.selectedItem}>
                            <span>{selectedItemText}</span>
                        </div>
                    ) : (
                        <div className={cls.placeholder}>
                            {t('TaskHeader.TaskExecutorsFilter.title')}
                        </div>
                    )}
                    {isActiveTypesFilter ? (
                        <UiButton
                            onClick={resetFilterTypes}
                            className={cls.resetIcon}
                            variant="icon"
                            startIcon={<Icon iconName="resetInput" />}
                        />
                    ) : (
                        <div
                            className={classNames(cls.arrow, {
                                [cls.openArrow]: isShow,
                            })}
                        >
                            <Icon iconName="selectArrow" />
                        </div>
                    )}
                </div>
                <div className={classNames(cls.types)}>
                    {executorsForFilter.map((executor) => (
                        <div
                            className={cls.typeItem}
                            onClick={onChangeCheckbox(executor.id)}
                            key={executor.id}
                        >
                            <Checkbox
                                classes={cls.checkbox}
                                isActive={filteredData.executors.includes(executor.id)}
                                title={executor.name}
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    }
);
